/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderDemiboy = createReactComponent("outline", "gender-demiboy", "IconGenderDemiboy", [["path", { "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M19 5l-5.4 5.4", "key": "svg-1" }], ["path", { "d": "M19 5h-5", "key": "svg-2" }]]);

export { IconGenderDemiboy as default };
//# sourceMappingURL=IconGenderDemiboy.mjs.map
